<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import Text from '@components/Text.svelte';
  import Alert from '@components/Alert.svelte';
  import CreateAccountModal from '@app-components/modal/CreateAccountModal.svelte';
  import UserAvatar from '@components/UserAvatar.svelte';
  import Track from '@utils/track';
  import CommentAjax from '@ajax/comment';
  import { getGroupStore } from '@stores/group';
  import GroupAjax from '@ajax/group';
  import RecObjectAjax from '@ajax/rec_object';
  import { clickOutside } from '@utils/clickOutside';

  import Notification from '@utils/notification';
  import UserAccountFlagAjax from '@ajax/user_account_flag';
  import jQuery from 'jquery';
  import { getCurrentUserStore } from '@stores/current_user';
  import UserTagRow from './UserTagRow.svelte';

  let currentUser = getCurrentUserStore('default');
  let groupStore = getGroupStore('groupStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  let commentStore = getGroupStore('commentStore');
  let submittedCommentStore = getGroupStore('submittedCommentStore');
  let commentBox;

  const dispatch = createEventDispatcher();

  export let recObjectId = null;
  let recObject = recObjectId ? recObjectsStore.find(recObjectId) : null;

  export let mobile;
  export let customGroupStore;
  export let inlineStyling = false;
  export let startFocused = false;
  export let commentContainerHeight;
  export let context;
  export let shouldRefreshData = true;
  export let editMode = false;

  let focusedStyling;

  let commentRef = commentStore;

  let group = customGroupStore || groupStore;
  let commentParentId = null;
  let commentText = '';
  let inputComment;
  let inputLength;
  let replyComment;
  let textEl;
  let textArea;
  let ckEditor;
  let createAccountModal = false;
  let showFlaggedLinkModal = false;
  let showFlaggedContentModal = false;
  let flaggedContentModalShown = false;
  let searchResults = [];
  let showSearchResults = true;
  let replyMode = false;
  let searchResultHeight = inlineStyling || mobile ? 250 : 350;

  $: searchResultPosition = searchResultHeight + 100 > commentContainerHeight ? 'bottom' : 'top';

  const selectContent = function () {
    setTimeout(() => {
      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(textEl);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }, 0);
  };

  let trackAccountCreated = function () {
    Track.commentAccountCreated({
      user: currentUser,
      recObject,
      group,
    });
  };

  let processError = async function (response) {
    if (!response['error']) {
      return false;
    }
    if (response['message'] == 'flagged_link_invite') {
      showFlaggedLinkModal = true;
      return true;
    }

    if (response['message'] == 'flagged_content') {
      let response = await UserAccountFlagAjax.get();

      flaggedContentModalShown = response.flagged_content_modal_seen;
      if (!flaggedContentModalShown) {
        UserAccountFlagAjax.flagContentModalSeen();
        flaggedContentModalShown = true;
        showFlaggedContentModal = true;
        return true;
      }
    }

    return false;
  };

  let refetchContent = async function () {
    if (!shouldRefreshData) {
      return;
    }

    if (recObjectId) {
      recObject.set(await RecObjectAjax.get(group, recObject));
    } else {
      group.set(
        await GroupAjax.get(group.id, {
          withErrorHandling: false,
        })
      );
    }
  };

  export let reset = function () {
    textArea.resetEditorValue();
    commentParentId = null;
    commentStore.set({});
    commentText = '';
    inputComment = '';
    replyComment = null;
    startFocused = false;
    replyMode = false;
    editMode = false;
  };

  let updateComment = async function (data) {
    try {
      let response = await CommentAjax.update(group, commentRef.comment, data);
      let errorReponse = await processError(response);
      if (errorReponse) {
        return;
      }
      let submittedData = { comment: response, parentId: commentParentId, context: context };

      submittedCommentStore.set(submittedData);

      dispatch('changed');
    } catch {}
    refetchContent();
    reset();
  };

  let saveComment = async function () {
    if (commentText == '') {
      Notification.send({
        text: "Comment can't be blank",
        type: 'error',
      });
      return;
    }

    if (!currentUser || !currentUser.id) {
      showCreateAccountModal();
      return;
    }

    let response = await CommentAjax.create(group, recObject, {
      body: commentText,
      parent_id: commentParentId,
    });

    let errorReponse = await processError(response);
    if (errorReponse) {
      return;
    }

    if (commentParentId == null) {
      await updateStoreObjects(response);
    } else {
      await refetchContent();
    }

    let submittedData = { comment: response, parentId: commentParentId, context: context };

    dispatch('changed');

    submittedCommentStore.set(submittedData);
    reset();
  };

  let showCreateAccountModal = function () {
    createAccountModal = true;
  };

  let updateStoreObjects = async function (newCommentObject) {
    if (!shouldRefreshData) {
      return;
    }

    if (recObjectId) {
      recObject.set(await RecObjectAjax.get(group, recObject));
    } else {
      newCommentObject.user = currentUser;
      var oldComments = groupStore.comments;
      oldComments.total = oldComments.total + 1;
      oldComments.data.push(newCommentObject);
      groupStore.set({ ...groupStore, comments: oldComments });
    }
  };

  export const insertMention = async function (comment) {
    try {
      if (!ckEditor) return;
      jQuery(textEl).focus();

      replyComment = comment;

      const mentionHTML = `<a class="mention" data-mention="@${comment.user.username}" data-tagged-user-id="${comment.user.id}" href="${comment.user.profile_path}">@${comment.user.name}</a>&nbsp;`;

      // Convert HTML to view and then to model
      const viewFragment = ckEditor.data.processor.toView(mentionHTML);
      const modelFragment = ckEditor.data.toModel(viewFragment);
      ckEditor.setData('');
      ckEditor.model.insertContent(modelFragment);
      selectContent();
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  let triggerCkEditorSelect = function (result) {
    ckEditor.model.document.fire('mention:selectItem', { item: result });
    setTimeout(() => {
      searchResults = [];
      searchResultSelectedIndex = -1;
    }, 50);
  };

  let setupCkEditor = function () {
    ckEditor.model.document.on('mention:renderList', (_evt, data) => {
      searchResults = data.items;
      showSearchResults = true;
      searchResultSelectedIndex = 0;
      const balloon = ckEditor.plugins.get('ContextualBalloon');
      if (balloon) {
        balloon.view.hide();
      }
    });

    ckEditor.model.document.on('mention:removeList', () => {
      setTimeout(() => {
        searchResults = [];
        showSearchResults = false;
        searchResultSelectedIndex = -1;
      }, 120);
    });
  };

  let totalUserTagRows = 0;
  let readyUserTagRows = 0;
  let isReady = false;

  $: {
    totalUserTagRows = searchResults.length;
    if (readyUserTagRows === totalUserTagRows && totalUserTagRows > 0) {
      setTimeout(() => {
        isReady = true;
      }, 50); // small delay to ensure everything is truly ready
    } else {
      isReady = false;
    }

    if (inputLength == 0) {
      searchResults = [];
      showSearchResults = false;
    }
  }

  let searchResultSelectedIndex = -1;
  let searchResultElements = [];
  let searchResultsContainer;

  let cycleSearchResults = function (event) {
    if (!searchResults.length) return;
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        if (searchResultSelectedIndex < searchResults.length - 1) {
          searchResultSelectedIndex++;
          scrollToSelected('down');
        }
        break;
      case 'ArrowUp':
        event.preventDefault();
        if (searchResultSelectedIndex > 0) {
          searchResultSelectedIndex--;
          scrollToSelected('up');
        }
        break;
      case 'Enter':
        if (searchResultSelectedIndex !== -1) {
          event.preventDefault();
          triggerCkEditorSelect(searchResults[searchResultSelectedIndex]);
          selectContent();
        }
        break;
      case 'Tab':
        if (showSearchResults) {
          event.preventDefault();
        }
        if (searchResultSelectedIndex !== -1) {
          triggerCkEditorSelect(searchResults[searchResultSelectedIndex]);
          selectContent();
        }
        break;
    }
  };
  const scrollToSelected = (direction) => {
    if (!searchResultsContainer) return;

    const selectedElement = searchResultsContainer.children[searchResultSelectedIndex];
    if (!selectedElement) return;

    const containerRect = searchResultsContainer.getBoundingClientRect();
    const elementRect = selectedElement.getBoundingClientRect();

    if (direction === 'down' && elementRect.bottom > containerRect.bottom) {
      searchResultsContainer.scrollTop += elementRect.bottom - containerRect.bottom;
    } else if (direction === 'up' && elementRect.top < containerRect.top) {
      searchResultsContainer.scrollTop -= containerRect.top - elementRect.top;
    }
  };

  const handleSubmitAction = async function () {
    if (showSearchResults && searchResults.length > 0) {
      // If search results are open, don't submit
      return;
    }

    let submitText = ckEditor.getData();

    if (submitText != '') {
      commentText = textEl.innerHTML;

      if (editMode) {
        await updateComment({
          body: commentText,
        });
      } else {
        await saveComment();
      }
    }

    dispatch('enter');
  };

  onMount(() => {
    let unsubCommentStore = commentStore.subscribe((x) => {
      if (x.context != context) {
        return;
      }

      if (x.startFocused) {
        startFocused = true;
      }

      commentRef = x;

      if (commentRef.reply && commentRef.comment != replyComment) {
        insertMention(commentRef.comment);
        commentParentId = commentRef.parent.id;
        replyMode = true;
      } else if (commentRef.edit) {
        editMode = true;
        inputComment = commentRef.comment.body;
        selectContent();
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (focusedStyling) {
        selectContent();
      }
    });

    return () => {
      commentStore.set({});
      commentParentId = null;
      unsubCommentStore();
      reset();
    };
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  * {
    --editable-focused-border-color: transparent;
  }

  .post-comment-text {
    align-self: flex-end;
    cursor: pointer;

    padding-bottom: 3px;
  }

  .comment-box {
    display: flex;
    position: relative;
    align-items: flex-start;
    font-size: 13px;

    &.mobile {
      padding-bottom: 15px;
    }

    .comment-avatar {
      width: 27px;
      height: 27px;
      flex-shrink: 0;
      margin-top: 7px;
      z-index: 2;
      pointer-events: none;

      &.rec-mobile {
        margin-top: 12px;
      }
    }

    .comment-body {
      margin-left: 15px;
      // background: #fff;
      color: #5e518e;
      border-radius: 15px;
      line-height: 24px;
      padding: 10px;
      padding-left: 15px;
      padding-right: 10px;
      width: 100%;
      display: block;
      flex-direction: column;
      border: 1px solid transparent;
      border-radius: 8px !important;
      border: 1px solid var(--neutral-input-gray, #ececec);
      background: var(--neutral-white, #fff) !important;
      &.focused {
        border: 1px solid $purple-60;
        background: #f5f3fc !important;
      }

      &.inline {
        background: #f5f3fc !important;
      }
    }

    .add-comment-body {
      padding-bottom: 4px;

      :global(.editable-content) {
        &:hover,
        &:focus {
          background: transparent !important;
        }
      }
    }

    .search-results {
      position: absolute;
      z-index: 15;
      background-color: #fff;
      width: inherit;
      overflow-y: scroll;
      height: var(--element-height);
      top: calc(-1 * var(--element-height) - 10px);
      left: 40px;
      box-shadow: 0px 22px 100px 0px rgba(0, 0, 0, 0.1);
      border-top-left-radius: 15px;
      border-bottom-right-radius: 15px;
      border-bottom-left-radius: 15px;
      max-width: 331px;

      &.mobile {
        max-width: 250px;
      }

      &.bottom {
        top: 50px;
      }

      .search-result {
        pointer-events: all;
        cursor: pointer;
        &.hovered {
          background-color: #f9f7ff;
        }
        &.selected {
          background-color: #f9f7ff;
        }
      }
    }
  }

  .extra-info {
    padding-bottom: 8px;
    padding-left: 1px;
    width: inherit;
    display: flex;
    flex-direction: row;
    gap: 6px;
    justify-content: space-between;

    .inner {
      display: flex;
      flex-direction: row;
      gap: 6px;
    }
    .icon {
      width: 12px;
      height: 12px;
    }
    .text {
      color: var(--Purple-Navigation-Purple, #a19bb8);
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    .right {
      padding-right: 6px;
      cursor: pointer;
    }
  }
</style>

<Alert
  mobile={mobile}
  on:yes-click={() => {
    showFlaggedLinkModal = false;
  }}
  yesButtonText="OK"
  cancelText={null}
  objectText={null}
  bind:show={showFlaggedLinkModal}>
  <div slot="content">
    <div class="spam-header">
      Adding a comment with a Benable link or invite code on someone else's list is not allowed.
    </div>
    <br />
    <div class="spam-alert-text">
      Adding comments that may be perceived as spam or taking other actions against our community standards and terms
      will result in your account getting suspended.
    </div>
  </div>
</Alert>
<Alert
  on:yes-click={() => {
    showFlaggedContentModal = false;
    saveComment();
  }}
  yesButtonClass={'use-default-style'}
  closeOnOverlayClick={false}
  mobile={mobile}
  yesButtonText={'Yes, this is not spam!'}
  objectText={null}
  cancelText={'Back'}
  bind:show={showFlaggedContentModal}>
  <div slot="content">
    <div class="spam-header">
      Adding comments that may be perceived as spam or that promote your own profile and lists can result in your
      account being suspended. <br /> <br /> Do you want to continue?
    </div>
  </div>
</Alert>
{#if createAccountModal}
  <div>
    <CreateAccountModal
      mobile={mobile}
      eventDetails={{ trigger_event: 'add_comment', group_base_id: group?.id, rec_object_id: recObject?.id }}
      successCallback={() => {
        createAccountModal = false;
        trackAccountCreated();
        saveComment();
      }}
      showPassword={true}
      saveButtonFlow={true}
      header="To add a first comment, please enter your info"
      bind:showModal={createAccountModal}
      beforeDataSend={(data) => {
        data['sign_up_source'] = {
          source: 'comment',
          group_base_id: group && group.id,
          rec_object_id: recObject && recObject.id,
        };
        return data;
      }} />
  </div>
{/if}
{#if replyMode || editMode}
  <div class="extra-info">
    <div class="inner">
      {#if replyMode}
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.58658 11.8932C9.73129 11.826 9.86221 11.7292 9.97188 11.6083C10.8755 10.5584 11.5517 9.31064 11.9525 7.9534C12.0133 7.73034 12.0158 7.49401 11.9596 7.2699C11.9033 7.0458 11.7906 6.84243 11.6336 6.68172C10.6466 5.71682 9.47098 4.99601 8.19063 4.5707C8.0374 4.51516 7.8751 4.49327 7.71352 4.50635C7.55195 4.51943 7.39446 4.56721 7.25058 4.64679C7.1067 4.72638 6.97941 4.83613 6.8764 4.9694C6.7734 5.10268 6.69681 5.25671 6.65128 5.4222C6.60575 5.58768 6.59222 5.76118 6.61149 5.93221C6.63077 6.10324 6.68247 6.26825 6.76345 6.41727C6.84443 6.56629 6.95302 6.69622 7.08266 6.79921C7.2123 6.9022 7.36029 6.97611 7.5177 7.01648C7.53453 7.02142 7.5514 7.02628 7.56826 7.03115C7.6987 7.06878 7.82866 7.10626 7.9377 7.17312C7.90097 7.18647 7.86447 7.20071 7.82796 7.21494C7.75496 7.24341 7.68194 7.27188 7.60716 7.29329C6.91747 7.49231 6.19247 7.50567 5.4976 7.33219C4.80272 7.1587 4.15984 6.80382 3.62695 6.29956C3.09407 5.79531 2.68796 5.15756 2.44528 4.44385C2.2026 3.73015 2.32354 1.58258 2.42944 0.83113C2.53907 0.0532045 0.923077 -0.564979 0.303677 0.83113C-0.0489383 2.01406 -0.0954088 3.2754 0.169157 4.48238C0.433722 5.68936 0.999538 6.79732 1.80704 7.68964C2.61454 8.58195 3.63385 9.22561 4.75768 9.55285C5.8815 9.88009 7.06826 9.8788 8.19302 9.54913C8.28944 9.52153 8.38629 9.48646 8.48204 9.45179C8.51254 9.44074 8.54293 9.42974 8.57316 9.41902C8.38445 9.67323 8.2451 9.83663 8.2451 9.83663C8.13543 9.95752 8.04917 10.1001 7.99124 10.2563C7.93331 10.4125 7.90485 10.5793 7.90747 10.747C7.9101 10.9147 7.94377 11.0802 8.00655 11.2339C8.06933 11.3877 8.16001 11.5267 8.27339 11.643C8.38677 11.7593 8.52064 11.8507 8.66736 11.9119C8.81408 11.9731 8.97077 12.003 9.12849 11.9998C9.28621 11.9965 9.44187 11.9603 9.58658 11.8932Z"
              fill="#D6CFEA" />
          </svg>
        </div>
        <div class="text">Replying to {commentRef.comment.user.name}</div>
      {/if}

      {#if editMode}
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M0 9.49965L0 12H2.50035L9.87804 4.62231L7.37769 2.12196L0 9.49965ZM11.805 2.69537C12.065 2.43534 12.065 2.01195 11.805 1.75191L10.2481 0.195027C9.98806 -0.065009 9.56466 -0.065009 9.30463 0.195027L8.08446 1.4152L10.5848 3.91554L11.805 2.69537Z"
              fill="#D6CFEA" />
          </svg>
        </div>
        <div class="text">Editing your comment</div>
      {/if}
    </div>

    <div
      class="right"
      on:click={() => {
        reset();
      }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        class="s-Wp9TNuklwgHD"
        ><path
          d="M6.08817 4.85052C6.07656 4.86216 6.06277 4.8714 6.04758 4.8777C6.0324 4.884 6.01612 4.88724 5.99968 4.88724C5.98324 4.88724 5.96696 4.884 5.95177 4.8777C5.93659 4.8714 5.92279 4.86216 5.91118 4.85052L1.28056 0.2194C1.13974 0.0787803 0.948833 -0.000140458 0.749826 1.87661e-07C0.550819 0.000140833 0.360019 0.0793311 0.219399 0.22015C0.0787798 0.360968 -0.000140447 0.55188 1.87633e-07 0.750887C0.000140822 0.949894 0.0793309 1.14069 0.220149 1.28131L4.84877 5.91193C4.86041 5.92354 4.86965 5.93734 4.87595 5.95252C4.88225 5.96771 4.88549 5.98399 4.88549 6.00043C4.88549 6.01687 4.88225 6.03315 4.87595 6.04833C4.86965 6.06352 4.86041 6.07731 4.84877 6.08892L0.220149 10.7195C0.150489 10.7892 0.0952246 10.8718 0.057512 10.9628C0.0197994 11.0538 0.000377086 11.1513 0.000353874 11.2498C0.000306992 11.4487 0.07928 11.6395 0.2199 11.7802C0.360519 11.9209 0.551266 12 0.750179 12C0.949092 12 1.13988 11.9211 1.28056 11.7805L5.91118 7.15033C5.92279 7.13869 5.93659 7.12946 5.95177 7.12316C5.96696 7.11686 5.98324 7.11361 5.99968 7.11361C6.01612 7.11361 6.0324 7.11686 6.04758 7.12316C6.06277 7.12946 6.07656 7.13869 6.08817 7.15033L10.7193 11.7805C10.789 11.8501 10.8716 11.9053 10.9626 11.943C11.0537 11.9806 11.1512 12 11.2497 12C11.4486 12 11.6393 11.9209 11.78 11.7802C11.8496 11.7105 11.9048 11.6279 11.9425 11.5368C11.9801 11.4458 11.9995 11.3483 11.9995 11.2498C11.9995 11.0509 11.9204 10.8602 11.7797 10.7195L7.14858 6.08892C7.13694 6.07731 7.12771 6.06352 7.12141 6.04833C7.11511 6.03315 7.11186 6.01687 7.11186 6.00043C7.11186 5.98399 7.11511 5.96771 7.12141 5.95252C7.12771 5.93734 7.13694 5.92354 7.14858 5.91193L11.7797 1.28131C11.9204 1.14069 11.9995 0.949946 11.9995 0.751033C11.9995 0.55212 11.9206 0.361336 11.78 0.22065C11.6393 0.0799639 11.4486 0.00090024 11.2497 0.000853358C11.0508 0.000806476 10.86 0.0797799 10.7193 0.220399L6.08817 4.85052Z"
          fill="black"
          class="s-Wp9TNuklwgHD"></path
        ></svg>
    </div>
  </div>
{/if}
<div
  class="comment-box {focusedStyling ? 'focused' : 'unfocused'}"
  class:mobile={mobile}
  bind:this={commentBox}
  on:click|preventDefault|stopPropagation={() => {
    dispatch('acted-upon');
  }}>
  <div
    style="display: flex; flex-direction: column; gap: 0px;"
    on:click|preventDefault|stopPropagation={() => {
      dispatch('acted-upon');
    }}>
    <div class="comment-avatar {mobile && context == 'rec' ? 'rec-mobile' : ''}">
      <UserAvatar user={currentUser} />
    </div>
  </div>
  {#if searchResults.length > 0 && showSearchResults}
    <div
      bind:this={searchResultsContainer}
      class="search-results purple-scrollbar-rounded-light-wide-rounded {inlineStyling
        ? 'inline'
        : ''} {searchResultPosition}"
      class:mobile={mobile}
      style="--element-height: {searchResultHeight}px;"
      tabindex="-1"
      use:clickOutside
      on:click_outside={() => {
        if (isReady) {
          showSearchResults = false;
        }
      }}>
      {#each searchResults as result, index}
        <div
          id={`option-${index}`}
          class="search-result"
          on:click|preventDefault={() => triggerCkEditorSelect(result)}
          on:mouseenter={() => (searchResultSelectedIndex = index)}
          on:mouseleave={() => (searchResultSelectedIndex = -1)}
          class:selected={searchResultSelectedIndex == index}
          role="option"
          bind:this={searchResultElements[index]}
          aria-selected={index === searchResultSelectedIndex}>
          <UserTagRow
            result={result}
            mobile={mobile}
            handleClick={() => triggerCkEditorSelect(result)}
            on:ready={() => {
              readyUserTagRows += 1;
            }} />
        </div>
      {/each}
    </div>
  {/if}
  <div
    class="comment-body add-comment-body editable-content-wrapper {inlineStyling ? 'inline' : ''} {focusedStyling
      ? 'focused'
      : 'unfocused'}">
    <div style="display: flex; flex-direction: row; padding-bottom: 6px; column-gap: 4px;">
      <Text
        bind:this={textArea}
        editor={true}
        editable={true}
        mobile={mobile}
        collapseAfterExpand={false}
        focus={startFocused}
        bind:textEl={textEl}
        bind:ckEditor={ckEditor}
        bind:text={inputComment}
        bind:textLength={inputLength}
        on:enter={() => {
          handleSubmitAction();
        }}
        on:enter-submit={() => {
          handleSubmitAction();
        }}
        on:blur={() => {
          focusedStyling = false;
          dispatch('blur');
        }}
        on:focus={() => {
          focusedStyling = true;
          dispatch('focus');
        }}
        on:file-upload-complete={(e) => {
          updateComment({
            body: e.detail.text,
          });
        }}
        on:editor-ready={() => {
          setupCkEditor();
        }}
        on:keydown={(e) => {
          cycleSearchResults(e);
        }}
        heartEmoji={true}
        starEyesEmoji={true}
        placeholder="Add a comment..." />
      {#if inputLength > 0}
        <img
          on:click={() => handleSubmitAction()}
          class="post-comment-text {mobile ? '' : 'desktop'}"
          alt="Post"
          src="/images/arrow-right.svg" />
      {/if}
    </div>
  </div>
</div>
